import apiConfig from './url-config'

const Api = {
  /**
   * @param  {} name : api name from the url-config
   * @param  {} form ; form data for POST api call
   * @param  {} params={} : query param string to append
   * @param  {} customHeaders={} : custom Headers to append to Headers
   */
  request(name, form = {}, params = {}, customHeaders = {}) {
    const config = apiConfig[name]
    const { method, headers } = config
    const isGet = this.isGet(method)
    const formData = { ...form }
    const appendPath = form.appendPath ? form.appendPath : ''
    if (appendPath) {
      delete formData.appendPath
    }
    const body = form ? this.createBody(formData) : ''
    const queryString = params ? this.createQueryString(params) : ''
    const requestOptions = this.getRequestOptions(
      method,
      { ...headers, ...customHeaders },
      body,
      isGet,
    )
    config.queryString = queryString
    config.requestOptions = requestOptions
    config.appendPath = appendPath
    return this.jsonReq(config)
  },
  basic(config) {
    const { queryString, requestOptions, appendPath } = config
    let { url } = config
    url = appendPath ? `${url}/${appendPath}` : url
    if (queryString) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + queryString
    }
    return fetch(url, requestOptions)
  },
  /**
   * @param  {} url : api url
   * @param  {} queryString : query string created using params object
   * @param  {} requestOptions : request options for the fetch call
   */
  jsonReq(config) {
    let original
    return this.basic(config).then((res) => {
      const { status: originalStatusCode, ok, headers } = res
      original = { originalStatusCode, ok, headers }
      return res.json()
    }).then(res => res)
      .catch(() => ({ ...original }))
  },
  /**
   * @param  {} form={} : stringified form data for  api call
   */
  createBody(form = {}) {
    return JSON.stringify(form)
  },

  /**
   * @param  {} params={} : create the query strings  for GET method calls
   */
  createQueryString(params = {}) {
    return Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join('&')
  },
  isGet(method) {
    return method === 'GET'
  },
  getRequestOptions(method = 'GET', headers, body, isGet) {
    let options = {
      method,
      headers,
      credentials: 'same-origin',
      redirect: 'follow',
    }
    if (!isGet) {
      options = { ...options, body }
    }
    return options
  },
}

export default Api



// WEBPACK FOOTER //
// ./services/api/index.js